export default __webpack_public_path__ + "static/media/liveFeedFile.fec90cb3.png";